import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Adds keys the branch lacks, each with the same text in every language — the
// Localization tab's "add the Client's missing keys" in one undo step. A key the
// branch already holds is left untouched, whatever its text.
export class AddLocalizationKeysCommand extends CommandBase {
    entries: {key: string; value: string}[];

    constructor(entries: {key: string; value: string}[]) {
        super();
        this.entries = entries;
    }

    execute(data: RemoteConstantsModel): boolean {
        let changed = false;
        for (const language in data.localization) {
            for (const {key, value} of this.entries) {
                if (key in data.localization[language]) continue;
                data.localization[language][key] = value;
                changed = true;
            }
        }

        return changed;
    }
}
